/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CustomerProfile = {
  /**
   * Unique customer identifier
   */
  id: number;
  /**
   * Customer full name (not unique; CI is the unique natural identifier)
   */
  customerName: string;
  /**
   * National identity document number (e.g. CI Bolivia); required for new customers; unique when set
   */
  identityDocumentNumber: Record<string, any>;
  /**
   * Customer email
   */
  customerEmail?: string;
  /**
   * Customer phone
   */
  customerPhone?: string;
  /**
   * Optional reference number 1 (CRM)
   */
  referenceNumber1?: Record<string, any>;
  /**
   * Optional reference number 2 (CRM)
   */
  referenceNumber2?: Record<string, any>;
  /**
   * Customer address
   */
  customerAddress?: string;
  /**
   * Date of birth
   */
  dateOfBirth?: string;
  /**
   * Gender
   */
  gender?: CustomerProfile.gender;
  /**
   * Total purchases amount
   */
  totalPurchases: number;
  /**
   * Number of purchases made
   */
  purchaseCount: number;
  /**
   * Loyalty points
   */
  loyaltyPoints: number;
  /**
   * Loyalty tier
   */
  loyaltyTier: CustomerProfile.loyaltyTier;
  /**
   * Preferred payment method
   */
  preferredPaymentMethod?: string;
  /**
   * Customer notes
   */
  customerNotes?: string;
  /**
   * Marketing consent
   */
  marketingConsent: boolean;
  /**
   * Referral source
   */
  referralSource?: string;
  /**
   * Creation timestamp
   */
  createdAt: string;
  /**
   * Last update timestamp
   */
  updatedAt: string;
};
export namespace CustomerProfile {
  /**
   * Gender
   */
  export enum gender {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
    OTHER = 'OTHER',
  }
  /**
   * Loyalty tier
   */
  export enum loyaltyTier {
    BRONZE = 'BRONZE',
    SILVER = 'SILVER',
    GOLD = 'GOLD',
    PLATINUM = 'PLATINUM',
  }
}
